export default "__VITE_ASSET__BQowrpUJ__"